<template>
  <div class="page">
    <table class="table table-hover w-100 mt-3 d-none d-md-table">
      <TableSort :sorts="sorts" @sortsUpdate="loadWithSort" />
      <tbody>
      <tr v-for="car of cars" :key="car.id" @click="$router.push(`/fuel-consumptions/car/${car.id}`)">
        <td>
          <TextHighlight class="highlighter" :queries="searchText">{{ car.brand }}</TextHighlight>
        </td>
        <td>
          <TextHighlight class="highlighter" :queries="searchText">{{ car.model }}</TextHighlight>
        </td>
        <td>
          <TextHighlight class="highlighter" :queries="searchText">{{ car.registration_plate }}</TextHighlight>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="mobile-table-view card mt-2 mb-2 p-2 d-md-none" v-for="car of cars" :key="car.id">
      <table v-if="cars.length > 0" class="table borderless">
        <tbody>
        <tr>
          <td style="border-top: none">Марка автомобиля</td>
          <td style="border-top: none">
            <TextHighlight class="highlighter" :queries="searchText">{{ car.brand }}</TextHighlight>
          </td>
        </tr>
        <tr>
          <td>Модель автомобиля</td>
          <td>
            <TextHighlight class="highlighter" :queries="searchText">{{ car.model }}</TextHighlight>
          </td>
        </tr>
        <tr>
          <td>Рег. номер</td>
          <td>
            <TextHighlight class="highlighter" :queries="searchText">{{ car.registration_plate }}</TextHighlight>
          </td>
        </tr>
        </tbody>
      </table>
      <router-link
        :to="`/fuel-consumptions/car/${car.id}`"
        class="btn btn-primary btn-md create-serve ml-auto"
      >
        Подробно
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Consumption',
  props: {
    page: {
      type: String,
      default: () => '1'
    }
  },
  data () {
    return {
      sorts: [
        {
          name: 'Марка автомобиля',
          storeName: 'servecar-brand',
          values: ['', 'brand', '-brand'],
          order: 0
        }, {
          name: 'Модель автомобиля',
          storeName: 'servecar-model',
          values: ['', 'model', '-model'],
          order: 1
        }, {
          name: 'Рег. номер',
          storeName: 'servecar-registration_plate',
          values: ['', 'registration_plate', '-registration_plate'],
          order: 2
        }
      ]
    }
  },
  mounted () {
    this.setTitle({
      items: [
        {
          title: 'Расход'
        }
      ]
    })
    this.loadCars({ page: Number(this.page) })
  },
  computed: {
    ...mapState('fuel/fuelConsumption', {
      consumptionList: state => state.items,
      searchText: state => state.searchText,
      pageCount: state => state.pageCount,
      isLoading: state => state.isLoading
    }),
    ...mapState('taxi/cars', {
      cars: state => state.items,
      searchText: state => state.searchText,
      pageCount: state => state.pageCount,
      isLoading: state => state.isLoading
    })
  },
  beforeDestroy () {
    this.abortLoading()
  },
  methods: {
    ...mapActions('fuel/fuelConsumption', [
      'loadItemsWith',
      'abortLoading',
      'removeItem',
      'setSearch',
      'loadItems',
      'setSearchText',
      'setSorts'
    ]),

    ...mapActions('taxi/cars', { loadCars: 'loadItems' }),
    ...mapActions('taxi', [
      'setTitle'
    ]),
    searchConsumption (e) {
      this.setSearchText(e.target.value)
      this.setSearch({ key: 'tracking_device.imei', value: e.target.value })
      this.setSearch({ key: 'brand', value: e.target.value })
      this.setSearch({ key: 'model', value: e.target.value })
      this.setSearch({ key: 'registration_plate', value: e.target.value })
      this.loadItems({ page: Number(this.page) })
    },
    loadWithSort (sorts) {
      this.setSorts(sorts)
      this.loadItems({ page: Number(this.page) })
    }
  },
  watch: {
    page () {
      this.loadItems({ page: Number(this.page) })
    }
  }
}
</script>

<style scoped>
  .highlighter >>> .text__highlight {
    border-radius: 0px;
    padding: 0.2em 0 0.2em 0;
    background: #fff2ae;
  }
</style>
